import type {
  PropertiesSectionType,
  RegionalPropertiesSoldResponse,
} from '@widget/api/queries/market/types';
import type { QueryFunctionContext } from '@tanstack/react-query';

export const MarketQueryKey = {
  all: ['market'] as const,
  propertiesAll: ['market', 'properties'] as const,
  properties({
    zipcode,
    tp_loc,
    tp_physical,
    city,
    radius,
    type,
  }: {
    zipcode?: string | null;
    tp_loc?: string | null;
    tp_physical?: string | null;
    city?: string | null;
    radius?: string | null;
    type?: PropertiesSectionType;
  }) {
    return [
      ...MarketQueryKey.propertiesAll,
      { zipcode, tp_loc, tp_physical, city, type, radius },
    ] as const;
  },
};

export const MarketQueryFn = {
  async properties({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof MarketQueryKey.properties>>) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(queryKey[2])) {
      if (value) {
        searchParams.set(key, value);
      }
    }
    if (!searchParams.size) {
      return null;
    }

    const response = await fetch(
      `/api-widget/${queryKey[0]}/${queryKey[1]}?${searchParams.toString()}`,
    );

    if (!response.ok) {
      throw new Error('Market properties request failed');
    }

    const content: RegionalPropertiesSoldResponse = await response.json();

    if (content.error) {
      throw new Error('Market properties error response');
    }

    return content.data;
  },
};
